<template>
  <div>
    <h6 class="mt-4">
      <!-- TKP-235 m.172–174: açıklamalar bilgi işaretinin arkasında -->
      {{ $t("process-data.datasources") }} <i class="bx bx-info-circle text-info hand" data-test="datasources-hint" v-b-tooltip.hover :title="$t('process-data.datasources-hint')"></i>
    </h6>
    <!-- TKP-240 b.1: organizasyon + kütüphane kaynaklarının tümü, alfabetik (ilk 1000 organizasyon kaydı "eksik liste" izlenimi veriyordu) -->
    <filter-select id="nodeDatasourceFilter" ref="nodeDatasourceFilter" :options-limit="LIMIT" :placeholder="$t('datasource.text')" :multiple="true" @filter="onDatasourceSearch" :selected="form.datasources" @changed="(v) => $emit('datasources', v)" />
    <new-entry-link :label="$t('process-data.create-new.link.datasource')" :placeholder="$t('process-data.create-new.name')" data-test="new-datasource" @add="(q) => $emit('datasources', addNewEntry(form.datasources, q, (n) => $t('process-data.create-new.datasource', { name: n })))" />
    <h6 class="mt-4">
      {{ $t("process-data.category-override") }} <i class="bx bx-info-circle text-info hand" data-test="category-override-hint" v-b-tooltip.hover :title="$t('process-data.category-override-hint')"></i>
    </h6>
    <filter-select id="nodeCategoryFilter" ref="nodeCategoryFilter" :placeholder="$t('data-category.text')" :multiple="false" @filter="onCategorySearch" :selected="form.category" @changed="(v) => $emit('category', v)" />
  </div>
</template>

<script>
/**
 * TKP-27 / 6.1 — düğüm özellikleri: kaynaklar (K1) ve süreç bazında kategori (K4).
 * TKP-124 kriter 2 — kaynak seçicisi ORGANİZASYON KAYNAK SÖZLÜĞÜNÜ sunar (`/datasource/paginate`): sürece önceden
 * bağlanmış olma şartı kalktı, istekte `process` kısıtı YOK. Sürece bağlı olmayan bir kaynak seçilip kaydedilince
 * süreç×kaynak kaydı backend'de örtük oluşur (kriter 3).
 */
// TKP-184 md.77: liste ada göre sıralı ve 100 ile sınırlı değil (en yeni 100 kayıt "eksik liste" izlenimi veriyordu)
export const datasourceSearchQuery = (value, language = "tr") => searchRequest(value, language, LIMIT);
const LIMIT = 10000; // TKP-240 b.1

import { addNewEntry, cachedPicker, mergeOrgAndLibrary, searchRequest, withCreateOption } from "../unified-picker";
import NewEntryLink from "./new-entry-link"; // TKP-218

export default {
  // TKP-124: `process` prop'u kalktı — kaynak seçicisi artık süreçle kısıtlanmıyor
  props: ["form"],
  components: { NewEntryLink }, // TKP-218
  data() {
    return { LIMIT, sourcePicker: null }; // TKP-240 b.1
  },
  methods: {
    addNewEntry, // TKP-218: şablondan
    async onDatasourceSearch(value, callback) {
      // TKP-240 b.1: organizasyon sözlüğü + karşılığı olmayan kütüphane kalemleri (`fromLibrary`; kaydederken organizasyona açılır), ada göre
      if (!this.sourcePicker) {
        this.sourcePicker = cachedPicker(async (v) => {
          const request = datasourceSearchQuery(v, this.currentLanguage);
          const [org, library] = await Promise.all([
            this.$store.dispatch("organizationDatasource/paginateForSearch", request),
            this.$store.dispatch("datasource/paginateForSearch", request).catch(() => ({ data: { docs: [] } })),
          ]);
          const lang = this.currentLanguage || "tr";
          const text = (d) => String((d && d.name && (d.name[lang] || d.name.tr || d.name.en)) || "").trim();
          return mergeOrgAndLibrary(org.data?.docs ?? [], library.data?.docs ?? []).sort((a, b) => text(a).localeCompare(text(b), lang));
        }, LIMIT);
      }
      // TKP-200 m.7: listede olmayan kaynak için "yeni veri kaynağı oluştur" (kaydederken sözlükte açılır)
      callback(withCreateOption(await this.sourcePicker(value), value, (q) => this.$t("process-data.create-new.datasource", { name: q })));
    },
    /**
     * TKP-184 md.76: organizasyon kategorileri + organizasyonda henüz karşılığı olmayan kütüphane kategorileri (ör. "İletişim").
     * Kütüphaneden seçilen kategori (`fromLibrary`) kaydederken organizasyon kategorisine çevrilir (`resolveNodeCategory`).
     */
    async onCategorySearch(value, callback) {
      const request = searchRequest(value, this.currentLanguage);
      const [org, library] = await Promise.all([
        this.$store.dispatch("organizationDataCategory/paginate", request),
        this.$store.dispatch("dataCategory/paginateForSearch", request).catch(() => ({ data: { docs: [] } })), // kütüphane okunamazsa yalnız organizasyon
      ]);
      callback(mergeOrgAndLibrary(org.data?.docs ?? [], library.data?.docs ?? []));
    },
  },
};
</script>
